import type { ReviewDimension } from '@anjabom/core';

export interface PrivateReviewDraft {
  scores: Record<ReviewDimension, number | null>;
  note: string;
  listPrice: string;
  bookingFee: string;
  discount: string;
  observedAt: string;
  verification: 'skip' | 'masked-local';
}
type DraftStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
export const reviewDraftKey = (id: string) => `anjabom.review-draft.v1:${id}`;
const fields = ['note', 'listPrice', 'bookingFee', 'discount', 'observedAt'] as const;
const dimensions = ['시야', '가림', '소리', '무릎', '의자', '출입'] as const;

export function readReviewDraft(storage: DraftStorage, id: string): { draft: PrivateReviewDraft | null; raw: string | null; problem: boolean } {
  let raw: string | null = null;
  try {
    raw = storage.getItem(reviewDraftKey(id));
    if (raw === null) return { draft: null, raw, problem: false };
    const row = JSON.parse(raw) as PrivateReviewDraft;
    if (!row || fields.some((field) => typeof row[field] !== 'string') || !row.scores || dimensions.some((key) => ![null, 0, 1, 2, 3].includes(row.scores[key]))) throw new Error('invalid draft');
    return { draft: { scores: row.scores, note: row.note, listPrice: row.listPrice, bookingFee: row.bookingFee, discount: row.discount, observedAt: row.observedAt, verification: 'skip' }, raw, problem: false };
  } catch { return { draft: null, raw, problem: true }; }
}

export function persistReviewDraft(storage: DraftStorage, id: string, draft: PrivateReviewDraft, expectedRaw: string | null): { ok: boolean; raw: string | null } {
  try {
    if (storage.getItem(reviewDraftKey(id)) !== expectedRaw) return { ok: false, raw: expectedRaw };
    // Deliberately exclude proof files, public consent, account/session and server identifiers.
    const raw = JSON.stringify({ scores: draft.scores, note: draft.note, listPrice: draft.listPrice, bookingFee: draft.bookingFee, discount: draft.discount, observedAt: draft.observedAt, verification: 'skip' });
    storage.setItem(reviewDraftKey(id), raw);
    return { ok: storage.getItem(reviewDraftKey(id)) === raw, raw };
  } catch { return { ok: false, raw: expectedRaw }; }
}
